import { render, staticRenderFns } from "./LinkedArticles.vue?vue&type=template&id=2824b317&scoped=true"
import script from "./LinkedArticles.vue?vue&type=script&lang=js"
export * from "./LinkedArticles.vue?vue&type=script&lang=js"
import style0 from "./LinkedArticles.vue?vue&type=style&index=0&id=2824b317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824b317",
  null
  
)

export default component.exports